import { render } from "./Setting.vue?vue&type=template&id=854f2cca"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
script.render = render

export default script